var number={
	
}
export default number;


// WEBPACK FOOTER //
// ./src/helpers/number.js